import React, { Component, createRef, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Input, Tree, Col, Spin, Checkbox, Popover } from 'antd';
import { FolderOpenOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import { isEqual, cloneDeep, debounce } from 'lodash';
import { callApi } from 'utils';
import PersonInfo from '../../components/PersonInfo';
import { SelectContext } from '../../context';
const prefixClx = 'select-modal-new';
const TreeNode = Tree.TreeNode;
const noop = () => { };
class SelectUser extends (PureComponent || Component) {
    static contextType = SelectContext;
	constructor (props) {
		super(props);
		//选中的用户列表
		this.targetUsers = [];
		//目标组织树
		this.targetOrg = [];
		//不可选择列表id的对象
		this.disabledObj = this.getDisabledObj(props.disabledSelects);
		this.state = Object.assign(
			{
				organizationId: props.organizations && props.organizations.id,
				expandedKeys: [],
				selectedKeys: [],
				searchText: '',
				keywords: '',
				userList: [],
				members: [],
				scrollViewHeight: 0,
			},
			this.getData(props.organizations)
		);
		this.treeBox = createRef();
		this.searchBox = createRef();
	}

	componentWillMount () {
		const { selects = [], origin = '', isMultiply = false } = this.props;
		//true：选择树进行的操作 false: resultbox进行的操作
		this.isFromCheck = false;

		//选中的用户列表
		this.targetUsers = [];
		!origin && this.handleCompatibleData(selects);
		if (isMultiply && selects.length) {
			this.setState({
				selectedKeys: selects.filter(val => (val.flowUserSelectionType === 'person' || val.sourceTypeA === 'source_user')).map(val => `${val.sourceIdB}-${val.sourceIdA}`)
			});
		}
	}

	componentDidMount() {
		let scrollViewHeight = 0;
		if (this.treeBox.current && this.searchBox.current) {
			const searchBox = window.getComputedStyle(this.searchBox.current);
			scrollViewHeight = this.treeBox.current.parentElement.clientHeight - parseInt(searchBox.height) - parseInt(searchBox.marginTop) - parseInt(searchBox.marginBottom);
		}
		this.setState({
			scrollViewHeight,
		});
	}

	componentWillReceiveProps (nextProps) {
		const { selects = [] } = nextProps;
		//在resultbox操作时要过滤掉部门
		if (!isEqual(this.props.selects, selects) && !this.isFromCheck) {
			this.setState({
				selectedKeys: selects.filter(val => (val.flowUserSelectionType === 'person' || val.sourceTypeA === 'source_user')).map(val => `${val.sourceIdB}-${val.sourceIdA}`)
			});
		}
		this.isFromCheck = false;
	}

	// 处理数据兼容
	handleCompatibleData = (selects) => {
		const { idKey } = this.props;
		const { manageSceneFlag } = this.context;
		const oldSelects = [...selects];
		const toHandleData = [];
		const selectedKeys = [];
		// 选用户兼容，没有部门id时设置主部门id
		selects.forEach((item, idx) => {
			if (item.flowUserSelectionType === 'person' || item.sourceTypeA === 'source_user') {
				if (item.sourceIdB === undefined) {
					toHandleData.push({
						pos: idx,
						id: item.sourceIdA,
					});
				} else {
					selectedKeys.push(`${item.sourceIdB}-${item.sourceIdA}`);
				}
			}
		});
		this.setState({
			selectedKeys,
		});

		if (toHandleData.length) {
			this.setState({
				loading: true,
			});
			callApi({
				api: '/org_v6/listPrimaryDepartmentByUser',
				data: {
					manageSceneFlag,
					organizationId: this.props.organizations.id,
					[`${idKey}s`]: toHandleData.map(it => it.id),
				},
				success: (res = []) => {
					this.setState({
						loading: false,
					});
					// 新的数据
					const newSelects = [...oldSelects];
					res.forEach((it, idx) => {
						newSelects[toHandleData[idx].pos] = { ...selects[toHandleData[idx].pos], sourceIdB: it.organizationDTO.id, sourceTypeB: 'source_department' };
					});
					// 删除旧数据
					this.props.removeItems(toHandleData.map(it => oldSelects[it.pos]));
					// 添加新数据
					this.props.addItems(toHandleData.map(it => newSelects[it.pos]));
				}
			});
		}
	};

	//封装不可选择列表
	getDisabledObj = (disabledList = []) => {
		const obj = {};
		disabledList.filter(val => val.flowUserSelectionType === 'person').forEach(val => {
			obj[Number(val.sourceIdA)] || (obj[Number(val.sourceIdA)] = true);
		});
		return obj;
	};

	getData = organizations => {
		let expandedKeys = [];
		if (organizations) {
			const id = 'dep' + String(organizations.id);
			expandedKeys = [id];
		}
		return { expandedKeys };
	};

	/**
	   * 根据选择的d增加或减少用户
	   */
	dealUserList = (param, checked) => {
		const { organizations = [], addItems, removeItems, idKey } = this.props;
		let { organizationId, allData } = param;
		this.targetUsers = [];
		const obj = {};
		//是否为机构
		if (allData.groupType) {
			//机构id先去掉前缀
			organizationId = organizationId.slice(3, organizationId.length + 1);
			this.getTargetOrg([organizations], Number(organizationId));
			this.generateUsers(this.targetOrg);
		} else {
			this.targetUsers = [allData];
		}
		if (checked) {
			addItems(this.transToSource(this.targetUsers.reduce((pre, cur) => {
				obj[`${cur.organizationId}-${cur[idKey]}`] ? noop() : obj[`${cur.organizationId}-${cur[idKey]}`] = true && pre.push(cur);
				return pre;
			}, [])));
		} else {
			removeItems(this.transToSource(this.targetUsers.reduce((pre, cur) => {
				obj[`${cur.organizationId}-${cur[idKey]}`] ? noop() : obj[`${cur.organizationId}-${cur[idKey]}`] = true && pre.push(cur);
				return pre;
			}, [])));
		}
	};

	//获取点击的节点下的组织树
	getTargetOrg = (list, organizationId) => {
		for (let i = 0; i < list.length; i++) {
			const { childrens } = list[i];
			if (list[i].id === organizationId) {
				this.targetOrg = [list[i]];
				return;
			}
			if (childrens.length > 0) {
				this.getTargetOrg(childrens, organizationId);
			}
		}
	};

	/**
	   * 数据整合成统一格式
	   */
	transToSource = (data) => {
		const { idKey, needAllData } = this.props;
		const temp = data.map(user => ({
			phoneNum: user.phoneNum,
			selectionName: user.name || user.contactName || '',
			flowUserSelectionType: 'person',
			sourceIdA: Number(user[idKey]),
			sourceTypeA: 'source_user',
			sourceDataA: needAllData ? user : undefined,
			sourceIdB: user.organizationId,
			sourceTypeB: 'source_department',
		}));
		return temp;
	};

	/**
	   * 生成部门下所有人(包含子部门)
	   */
	generateUsers = (list = []) => {
		const { untrackStatus, idKey } = this.props;
		const { disabledObj } = this;
		for (let i = 0; i < list.length; i++) {
			const { memberList = [], childrens = [] } = list[i];
			if (memberList.length > 0) {
				if (untrackStatus === 1) {
					this.targetUsers = this.targetUsers.concat(memberList.filter(item => item.targetId !== 0 && !disabledObj[item[idKey]]));
				} else {
					this.targetUsers = this.targetUsers.concat(memberList.filter(item => !disabledObj[item[idKey]]));
				}
			}
			if (childrens.length > 0) {
				this.generateUsers(childrens);
			}
		}
	};

	/**
	 * 生成部门组织树状数据结构
	 */
	generateNodes = list => {
		const genFunc = (list) => {
			const { disabledObj = {} } = this;
			const { untrackStatus, idKey, selects, isLazyLoadData } = this.props;
			const { searchText } = this.state;
			return list.map(node => {
				let { children = [], name, id, contactInfoDTOS = [], detailId, selectedFlag, targetId, isUser, isLeaf, organizationId } = node;
				if (contactInfoDTOS.length > 0) {
					contactInfoDTOS.forEach(val => {
						// 未激活用户，不能用targetId的做标识，因为都是0
						val.id = val.targetId === 0 && idKey === 'targetId' ? val.detailId : val[idKey];
						val.isUser = true;
					});
					const _contactInfoDTOS = searchText ? contactInfoDTOS.filter(item => ~item?.name?.indexOf(searchText)) : contactInfoDTOS;
					children = children.concat(_contactInfoDTOS);
				}
				const nodeDisabled = disabledObj[id] || selectedFlag === 0;
				if (children && children.length > 0) {
					return (
						<TreeNode
							key={isUser ? String(id) : `dep${id}`}
							disabled={nodeDisabled}
							selectable={false}
							allData={node}
							isLeaf={ isLazyLoadData && !!isLeaf }
							title={<div title={name + (targetId === 0 ? '（未激活）' : '')} className={`${prefixClx}-node`}>
								<span className={`${prefixClx}-node-name`}>
									<FolderOpenOutlined className='type-icon' />{name}
								</span>
							</div>}
						>
							{genFunc(children, id)}
						</TreeNode>
					);
				}
				const selected = (() => {
					if (untrackStatus === 1 && targetId === 0) {
						return false;
					}
					return selects.some(selectNode => selectNode.sourceIdA === node[idKey]);
				})();
				return (
					<TreeNode
						key={isUser ? `${organizationId}-${id}` : `dep${id}`}
						disabled={nodeDisabled || (untrackStatus === 1 && targetId === 0)}
						allData={node}
						selectable={!!isUser}
						isLeaf={ isUser || (isLazyLoadData && !!isLeaf) }
						title={
							<div title={name + (targetId === 0 ? '（未激活）' : '')} className={`${prefixClx}-node`}>
								{
									isUser ? (
										<Popover title={name} mouseEnterDelay={0.5} content={<PersonInfo detail={node} />}>
											<span className={`${prefixClx}-node-name`}>
												{detailId ? <UserOutlined className='type-icon' /> : <FolderOpenOutlined className='type-icon' />}
												{name}{(targetId === 0 ? '（未激活）' : '')}
											</span>
										</Popover>
									) : (
										<span className={`${prefixClx}-node-name`}>
											{detailId ? <UserOutlined className='type-icon' /> : <FolderOpenOutlined className='type-icon' />}
											{name}{(targetId === 0 ? '（未激活）' : '')}
										</span>
									)
								}
								{isUser ? (
									<span className={`${prefixClx}-node-handle`}>
										<Checkbox disabled={nodeDisabled || (untrackStatus === 1 && targetId === 0)} checked={selected}/>
									</span>
								) : null}
							</div>
						}
					/>
				);
			});
		};
		// 递归生成 react node
		const nodes = genFunc(list);
		const handleNodes = nodes => {
			let anyActive = false;
			for (let index = 0; index < nodes.length; index++) {
				const node = nodes[index];
				if (node.props.children) {
					if (node.props.disabled) {
						continue;
					}
					const childActive = handleNodes(node.props.children);
					const newNode =	React.cloneElement(node, {
						disabled: !childActive
					});
					nodes[index] = newNode;
					anyActive = anyActive || childActive;
				} else {
					if (Array.isArray(node.props.allData.children)) {
						anyActive = true;
					} else if (anyActive) {
						break;
					} else if (!node.props.disabled) {
						anyActive = true;
						break;
					}
				}
			}
			return anyActive;
		};
		// 递归处理 react node，子节点全部禁用时，父节点禁用
		handleNodes(nodes);
		return nodes;
	};

	/**
	 * 生成搜索结果数据结构
	 */
	generateList = list => {
		const { disabledObj } = this;
		const { untrackStatus, idKey, selects } = this.props;
		return list.map(node => {
			const { contactName, visibleFlag, targetId, detailId, organizationId, fullPathDptName } = node;
			const id = idKey === 'targetId' && targetId === 0 ? detailId : node[idKey];
			const nodeDisabled = disabledObj[id] || visibleFlag === 0;
			const selected = (() => {
				if (untrackStatus === 1 && targetId === 0) {
					return false;
				}
				return selects.some(selectNode => selectNode.sourceIdA === node[idKey]);
			})();
			return (
				<TreeNode
					key={`${organizationId}-${id}`}
					disabled={nodeDisabled || (untrackStatus === 1 && targetId === 0)}
					allData={node}
					title={<div title={contactName + (targetId === 0 ? '（未激活）' : '')} className={`${prefixClx}-node`}>
						<Popover title={contactName} mouseEnterDelay={0.5} content={<PersonInfo detail={node} />}>
							<span className={`${prefixClx}-node-name`}>
								<UserOutlined className='type-icon' />
								{contactName}{(targetId === 0 ? '（未激活）' : '')}
							</span>
						</Popover>
						<span className={`${prefixClx}-node-handle`}>
							<Checkbox disabled={targetId === 0} checked={selected} />
						</span>
					</div>}
				/>
			);
		});
	};

	/**
	 * 获取当前选中树节点的子节点keys
	 */
	getTreeChildKeys = node => {
		const childKeys = [];
		const loop = (childrens = []) => {
			childrens.forEach(item => {
				childKeys.push(item.id);
				if (item.childrens && item.childrens.length) loop(item.childrens);
				if (item.memberList && item.memberList.length) loop(item.memberList);
			});
		};
		if (node.childrens && node.childrens.length) loop(node.childrens);
		if (node.memberList && node.memberList.length) loop(node.memberList);
		return childKeys;
	};

	/**
	 * 选中某项
	 * @param {string[]} selectedKeys
	 */
	onSelect = (selectedKeys, { node, selected }) => {
		const eventKey = node.key;
		this.isFromCheck = true;
		this.setState({ selectedKeys });
		this.dealUserList({
			organizationId: eventKey,
			allData: node.allData
		}, selected);
	};

	/**
	 * 点击展开/收缩树节点
	 */
	onExpand = (keys, info) => {
		this.setState({
			expandedKeys: keys
		});
	};

	/**
	 * 根据关键字搜索
	 */
	searchByKeywords = (keywords = '') => {
		const { privilegeFilterFlag, isSearchFromExist, organizations = [] } = this.props;
		const { manageSceneFlag } = this.context;
		const { organizationId } = this.state;
		const members = [];
		keywords = keywords.trim();
		if (keywords) {
			this.setState({ loading: true, showSearchBox: true, searchText: keywords, });
			if (isSearchFromExist) {
				const loopSearch = (node) => {
					const { children, contactInfoDTOS } = node;
					if (contactInfoDTOS && contactInfoDTOS.length) {
						contactInfoDTOS.forEach(contact => {
							if (contact?.name?.includes(keywords)) {
								members.push({
									...contact,
									contactName: contact.name
								});
							}
						});
					}
					if (children && children.length) {
						children.forEach(child => {
							loopSearch(child);
						});
					}
				};
				loopSearch(organizations);

				this.setState({
					members,
					loading: false,
				});
			} else {
				callApi({
					api: '/newOrg/findOrgPersonal',
					data: {
						organizationId,
						keywords,
						privilegeFilterFlag,
						appId: window.$$context.appId,
						manageSceneFlag
					},
					success: ({ members = [] }) => {
						this.setState({
							members,
							loading: false,
						});
					}
				});
			}
		} else {
			this.setState({
				loading: true,
				showSearchBox: true,
				searchList: [],
				searchText: keywords,
			}, () => {
				this.setState({
					loading: false,
				});
			});
		}
	};

	// 防抖
	searchByKeywordsDebounced = debounce(this.searchByKeywords, 500);

	render () {
		const { loading, searchText, expandedKeys, selectedKeys, members = [], showSearchBox, scrollViewHeight } = this.state;
		const { organizations, lazyLoadOrganization, isMultiply = false } = this.props;
		console.log('selectedKeys', selectedKeys);
		return (
			<Col className='tree-box' ref={this.treeBox}>
				<div className='select-box-search' ref={this.searchBox}>
					<Input
						placeholder="请输入姓名"
						prefix={<SearchOutlined />}
						onChange={e => this.searchByKeywordsDebounced(e.target.value)}
						allowClear
					/>
				</div>
				<div className={'select-scroll-view'}>
					{
						showSearchBox && searchText
							? loading
								? <Spin className='tree-box-center' />
								: members.length < 1
									? <div className='tree-box-center'>未找到相关结果</div>
									: <Tree
											selectedKeys={cloneDeep(selectedKeys)}
											onSelect={this.onSelect}
											selectable
											multiple={isMultiply}
											height={scrollViewHeight}
										>
											{this.generateList(members)}
										</Tree>
							: loading
								? <Spin className='tree-box-center' />
								: <Tree
										height={scrollViewHeight}
										expandedKeys={cloneDeep(expandedKeys)}
										selectedKeys={cloneDeep(selectedKeys)}
										onExpand={this.onExpand}
										onSelect={this.onSelect}
										multiple={isMultiply}
										selectable
										loadData={lazyLoadOrganization}
									>
										{this.generateNodes([organizations])}
									</Tree>
					}
				</div>
			</Col>
		);
	}
}

SelectUser.propTypes = {
	// 组织架构数据
	organizations: PropTypes.object.isRequired,
	// 选中的列表， 数据结构为 [{selectionName: 显示名称, flowUserSelectionType: 'person', sourceIdA: ID, sourceTypeA: 'source_user'}]
	// selectionName、sourceIdA 必传， flowUserSelectionType、sourceTypeA 都为固定值，根据义务是否有需求来选择传入
	selects: PropTypes.array.isRequired,
	// 选中的用户改变时的回调
	onChange: PropTypes.func.isRequired,
	// 选择类型：checkbox（默认） 多选，radio 单选。
	selectType: PropTypes.string,

	/* 以下是configs额外传进来的参数 */
	// 不可选的用户列表，数据结构为 [{sourceIdA: 用户id}]
	disabledSelects: PropTypes.array,
	// sourceIdA 所代表的key，默认值为 targetId
	idKey: PropTypes.string,
	// 是否需要返回所选人员的全部数据，如果为true，则在selects中将添加一个字段 sourceDataA，默认为false
	needAllData: PropTypes.bool,
	// 未注册用户的状态：1 不可选择（默认），2 可选择
	untrackStatus: PropTypes.number,

	addItems: PropTypes.func.isRequired, // 选中一个条目的回调
	removeItems: PropTypes.func.isRequired, // 选中一个条目的回调

	isLazyLoadData: PropTypes.bool, // 是否使用对数据进行懒加载的功能
	lazyLoadOrganization: PropTypes.func, // 使用懒加载数据的时候，需要在获取子部门时调用的方法
};

SelectUser.defaultProps = {
	disabledSelects: [],
	idKey: 'targetId',
	needAllData: false,
	untrackStatus: 1
};

export default SelectUser;
